import React, { FC } from "react";
import { DateTimeISO } from "shared-ts-types";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";
import { _throw } from "shared-ts-utils-core";
import { useMergeSx } from "./useMergeSx";
import { PropertyEditBaseProps } from "./PropertyEditBaseProps";
import { usePropertyEditBase } from "./usePropertyEditBase";

export interface PropertyEditDateProps extends PropertyEditBaseProps {
  value: DateTimeISO;
  disableFuture?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
}

export const PropertyEditDate: FC<PropertyEditDateProps> = (props) => {
  const { removable, handleRemove } = usePropertyEditBase(props);
  const sx = useMergeSx(
    {
      width: props.fullWidth ? "100%" : "25ch",
    },
    props.sx,
    [props.sx, props.fullWidth]
  );

  if (props.value != null && typeof props.value !== "string") {
    throw new Error("value must be of type string: " + props.value);
  }
  const value =
    props.value != null
      ? DateTime.fromISO(props.value).setLocale("no")
      : props.value === null
      ? null
      : undefined;

  const handleChange = (value: DateTime | null) => {
    props.onChange(
      value != null ? value.toISO() : null,
      props.name ?? _throw(new Error("name cannot be null"))
    );
  };

  return (
    <DatePicker
      label={props.label}
      value={value}
      disableFuture={props.disableFuture}
      sx={sx}
      inputRef={props.inputRef}
      onChange={handleChange}
      slotProps={{
        textField: {
          size: props.size,
          fullWidth: props.fullWidth,
          helperText: props.helperText,
          error: props.error,
          onBlur: props.onBlur,
        },
      }}
    />
  );
};
